// React
import React from 'react';
// Material-UI
import { Typography } from "@material-ui/core";
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * 
 * @typedef {Object} Props
 * @property {string} titulo Título de etiqueta
 * @property {string | undefined} detalle Contenido en texto
 * @property {React.ReactNode} componente Componente
 * @property {string} contentWidth Ancho de contenido
 */

/**
 * Tarjeta
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const EtiquetaContenido = ({ 
    titulo = '',
    detalle = '', 
    componente,
    contentWidth,
}) => {
    // Idioma
    
    // Token
    
    // Estados


    // Vista
    return (
        <div>
            <table style= {{ borderCollapse: 'collapse', borderSpacing: 0, margin: '2px', width: '100%' }}>
                <tbody>
                    <tr>
                        <td style={{ border: '1px solid #0000001f', color: '#0000008a', textAlign: 'center', padding:'2px 4px 2px 4px', backgroundColor: '#f7f7f7' }}>
                            <b>{titulo}</b>
                        </td>
                        <td style={{ border: '1px solid #0000001f', textAlign: 'center', padding: '5px', width: contentWidth }}>
                            {componente
                                ? componente
                                : <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>{detalle}</Typography>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
